import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { CHANGE_TO_FREE_STYLE_MODAL } from '@chegg-wt/core/state/modals/constants'
import { closeModal } from '@chegg-wt/core/state/modals/actions'
import {
  emitComponentViewEvent,
  userClick,
} from '@chegg-wt/core/state/instrumentation/actions'
import { styleSelected } from '@chegg-wt/core/state/currentProject/actions'
import { navigated } from '@chegg-wt/core/state/app/actions'
import { modalDataSelector } from '@chegg-wt/core/state/modals/selectors'
import { componentOrigins } from '@chegg-wt/core/state/instrumentation/rio/clickstreamComponentViews'
import {
  currentStyleSelector,
  styleGateFlagSelector,
} from '@chegg-wt/core/state/currentProject/selectors'
import { createCitationSourceTypeSelector } from '@chegg-wt/core/state/createCitation/selectors'
import { origins } from '@chegg-wt/core/state/instrumentation/rio/clickstreamInteractions'
import { ModalWrapper, DefaultBackdrop, PositioningWrapper } from '../styled'
import {
  BACKDROP,
  MODAL_CONTENT,
  TITLE_TEXT,
  CONTINUE_BUTTON,
  NEVER_MIND_BUTTON,
} from './testIds'
import { ChangeToFreeStyleModalProps } from './types'
import * as Styled from './styled'
import {
  CONTINUE,
  MAX_WIDTH,
  NEVERMIND,
  TITLE_TEXT as TITLE,
  INFO_TEXT as INFO,
} from './constants'

export const ChangeToFreeStyleModal: React.FC<ChangeToFreeStyleModalProps> = ({
  closeModal,
  modalData,
  isStyleGateFlagEnabled,
  styleSelected,
  emitComponentViewEvent,
  projectStyle,
  currentSourceType,
  userClick,
}) => {
  const handleCloseModal = () => {
    closeModal(CHANGE_TO_FREE_STYLE_MODAL)
  }

  const handleContinue = () => {
    userClick({ origin: origins.changeCitationStyleModalContinueClick })

    styleSelected(modalData.changeToStyle, false, true, isStyleGateFlagEnabled)
    if (!modalData.callbackFn) {
      // if no callbackFn, close modal directly
      return handleCloseModal()
    }
    modalData?.callbackFn?.() // create citation
  }

  useEffect(() => {
    emitComponentViewEvent({
      origin: componentOrigins.changeCitationStyleModal,
      metadata: {
        source: currentSourceType,
        style: projectStyle,
      },
    })
  }, [])

  return (
    <ModalWrapper
      backdrop
      show
      renderBackdrop={() => <DefaultBackdrop data-test={BACKDROP} />}
    >
      <PositioningWrapper>
        <Styled.ModalContent
          fullMobileModal={false}
          maxWidth={MAX_WIDTH}
          data-test={MODAL_CONTENT}
        >
          <Styled.ContentContainer>
            <Styled.TitleText data-test={TITLE_TEXT}>{TITLE}</Styled.TitleText>
            <Styled.InfoText>{INFO}</Styled.InfoText>

            <Styled.CTAContainer>
              <Styled.NeverMindCTA
                data-test={NEVER_MIND_BUTTON}
                onClick={handleCloseModal}
              >
                {NEVERMIND}
              </Styled.NeverMindCTA>

              <Styled.ContinueButton onClick={handleContinue} data-test={CONTINUE_BUTTON}>
                {CONTINUE}
              </Styled.ContinueButton>
            </Styled.CTAContainer>
          </Styled.ContentContainer>
        </Styled.ModalContent>
      </PositioningWrapper>
    </ModalWrapper>
  )
}

const mapStateToProps = (state) => ({
  modalData: modalDataSelector(state),
  isStyleGateFlagEnabled: styleGateFlagSelector(state),
  projectStyle: currentStyleSelector(state),
  currentSourceType: createCitationSourceTypeSelector(state),
})

const mapDispatchToProps = {
  closeModal,
  styleSelected,
  navigated,
  emitComponentViewEvent,
  userClick,
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangeToFreeStyleModal)
